import { render, staticRenderFns } from "./UsloviKupovine.vue?vue&type=template&id=460850f0&"
import script from "./UsloviKupovine.vue?vue&type=script&lang=js&"
export * from "./UsloviKupovine.vue?vue&type=script&lang=js&"
import style0 from "./UsloviKupovine.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports